import React, { useEffect, useRef, useState } from 'react';
import './checkpoint-edit-form.styles.scss';
import ManageContentInformation from '../blocks/information.component';
import ManageContentRewards from '../blocks/rewards.component';
import ManageChallengeInputType from '../blocks/challenge-input-type.component';
import { getQueryFromFirestore } from '@/utils/getDataFromDbSimplified';
import { createPathFromTimestamp } from '@/utils/createPathFromTimestamp';

const CheckpointEditForm = ({
  gameData,
  gameStats,
  checkpoint,
  saveCheckpoint,
  gameElements,
  setAlertMessage
}) => {

  const [formData, setFormData] = useState({});
  const [ challengesToImport, setChallengesToImport ] = useState([]);
  const dataRef = useRef({});

  useEffect(() => {
    if (!checkpoint) return;
    dataRef.current = {...checkpoint};
    setFormData(dataRef.current);
  }, [checkpoint])
  
  useEffect(() => {
    getChallengesToImport();
  }, [])

  function getChallengesToImport() {
    getQueryFromFirestore({
      'path': `games/${gameData.gameId}/gameElements`,
      'queryArray': [{
        'field': 'type',
        'operator': '==',
        'value': 'challenge'
      }],
      'callback': callback,
      'once': true
    })
    function callback(challenges) {
      console.log(challenges);
      setChallengesToImport(Object.values(challenges));
    }
  }

  function saveData(key, value) {
    dataRef.current = {
      ...dataRef.current,
      [key]: value
    }
    setFormData(dataRef.current);
    console.log('saved data: ', dataRef.current);
  }

  function importChallengeData(challenge) {
    const keysToImport = [
      // from information block
      'name',
      'desc',
      // from input type block
      'opt_inputType',
      'opt_inputOptions',
      'opt_correctAnswers',
      'opt_correctOptionIndex',
      'opt_autoApprove',
      'opt_allowFileUpload', 
      // from rewards block
      'opt_earnedPoints',
      'opt_earnedPointsMin',
      'opt_earnedPointsMax',
      'opt_earnedCurrency',
      'opt_earnedCurrencyMin',
      'opt_earnedCurrencyMax',
      'opt_earnedBadges',
      'opt_earnedItems',
      'opt_earnedPrizePacks'
    ]
    keysToImport.forEach(key => {
      console.log(key);
      console.log(challenge[key]);
      // nullish check, not truthiness — opt_correctOptionIndex of 0 is a
      // valid correct answer and was being dropped on import
      if (challenge[key] !== null && challenge[key] !== undefined) {
        if (key === 'desc') {
          // remove html line breaks and split into array for checkpoint description
          const desc = challenge.desc.replace(/<br\s*\/?>/gi, '\n').split('\n');
          saveData(key, desc);
        } else {
          saveData(key, challenge[key]);
        }
        saveData(key, challenge[key]);
      }
    })
  }

  function handleSubmit(data) {
    const req = [
      'name',
      'desc'
    ]
    for (let i = 0; i < req.length; i++) {
      const key = req[i];
      if (!data[key]) {
        setAlertMessage('Please give this checkpoint a Name and Instructions before saving.');
        return;
      }
    }

    const inputType = data.opt_inputType || 'shortAnswer';
    const validMcOptions = Array.isArray(data.opt_inputOptions)
      ? data.opt_inputOptions.filter(o => typeof o === 'string' && o.trim().length > 0)
      : [];

    if (inputType === 'multipleChoice' && validMcOptions.length === 0) {
      setAlertMessage('Please add at least one multiple-choice option before saving this Checkpoint.');
      return;
    }

    // an auto-approving checkpoint with no answer key can never be graded,
    // so block the save rather than leaving submissions stuck in review
    if (data.opt_autoApprove && inputType === 'multipleChoice') {
      const selectedIndex = data.opt_correctOptionIndex;
      const selectedOption =
        typeof selectedIndex === 'number' && Array.isArray(data.opt_inputOptions)
          ? data.opt_inputOptions[selectedIndex]
          : null;
      if (
        selectedIndex === null ||
        selectedIndex === undefined ||
        !selectedOption ||
        selectedOption.trim().length === 0
      ) {
        setAlertMessage('Auto-approval is enabled. Please choose a valid correct multiple-choice option before saving.');
        return;
      }
    }

    if (data.opt_autoApprove && inputType === 'shortAnswer') {
      const validAnswers = Array.isArray(data.opt_correctAnswers)
        ? data.opt_correctAnswers.filter(a => typeof a === 'string' && a.trim().length > 0)
        : [];
      if (validAnswers.length === 0) {
        setAlertMessage('Auto-approval is enabled. Please add at least one correct short-answer response before saving.');
        return;
      }
    }

    console.log('submitting checkpoint data: ', data);
    const checkpointData = {
      ...checkpoint,
      ...data
    }
    checkpointData.status = 'active';
    saveCheckpoint(checkpointData);
  }

  return (
    <div className='checkpoint-edit-form'>
      {
        (formData) &&
        <><ManageContentInformation
          type='checkpoint'
          saveData={saveData}
          formData={formData}
          gameElements={gameElements}
          importChallengeForCheckpoint={importChallengeData}
          challengesToImport={challengesToImport}
          textEditorLabel="Checkpoint Instructions" />
        <div className='g-space-2'></div>
        <ManageChallengeInputType
          saveData={saveData}
          formData={formData}
          type='checkpoint' />
        <div className='g-space-2'></div>
        <ManageContentRewards
          gameData={gameData}
          gameStats={gameStats}
          type='checkpoint'
          saveData={saveData}
          formData={formData}
          gameElements={gameElements}
          text='completing this Checkpoint' />
        <div className="g-space-1"></div>
        <div className='required'>* = Required</div>
        <div className='buttons'>
          <button
            className='g-button primary'
            onClick={() => handleSubmit({ ...checkpoint, ...formData })}>
            Save Checkpoint
          </button>
        </div>
        </>
      }
    </div>
  )
}

export default CheckpointEditForm